import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../app/constants";

export const topPartnerIncome = createAsyncThunk(
  "topPartnerIncome/topPartnerIncome",
  async ({ uid }) => {
    /// ******** API oncetime_revenue_per_day ********
    const response = await axios.post(`${baseUrl}top_partner_income`, {
      uid: uid,
    });
    return response.data.response;
  }
);

const changePasswordEntity = createEntityAdapter({
  selectId: (topPartnerIncome) => topPartnerIncome.id,
});

const changePasswordSlice = createSlice({
  name: "topPartnerIncome",
  initialState: changePasswordEntity.getInitialState(),
  extraReducers: {
    [topPartnerIncome.pending]: (state) => {
      // console.log('pending')
    },
    [topPartnerIncome.fulfilled]: (state, action) => {
      changePasswordEntity.setAll(state, action.payload);
    },
    [topPartnerIncome.rejected]: (state) => {
      // console.log("rejected");
    },
  },
});

export const changePasswordSelector = changePasswordEntity.getSelectors(
  (state) => state.topPartnerIncome
);
export default changePasswordSlice.reducer;
